<script setup>
import { computed } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';
import {
  describeTrigger,
  describeActions,
  describeConditions,
} from './helpers/describeAutomation';

const props = defineProps({
  automation: { type: Object, required: true },
  funnels: { type: Array, default: () => [] },
});

defineEmits(['edit', 'delete', 'toggle']);

const trigger = computed(() =>
  describeTrigger(props.automation, props.funnels)
);
const actions = computed(() =>
  describeActions(props.automation.actions, props.funnels)
);
const conditions = computed(() =>
  describeConditions(props.automation.conditions)
);
</script>

<template>
  <div
    class="flex items-center justify-between px-4 py-3 border-b border-n-weak"
  >
    <div class="min-w-0">
      <p class="mb-0 font-medium truncate text-n-slate-12">
        {{ automation.name }}
      </p>
      <p class="mb-0 text-sm text-n-slate-11">{{ trigger }}</p>
      <p class="mb-0 text-sm text-n-slate-11">{{ actions.join(' · ') }}</p>
      <p v-if="conditions.length" class="mb-0 text-xs text-n-slate-10">
        {{ $t('AUTOMATION.CRM.FORM.CONDITIONS') }}: {{ conditions.join(' · ') }}
      </p>
    </div>
    <div class="flex items-center justify-end flex-shrink-0 gap-3">
      <ToggleSwitch
        :model-value="automation.active"
        @change="$emit('toggle', automation)"
      />
      <Button
        v-tooltip.top="$t('AUTOMATION.FORM.EDIT')"
        icon="i-woot-edit-pen"
        slate
        sm
        @click="$emit('edit', automation)"
      />
      <Button
        v-tooltip.top="$t('AUTOMATION.FORM.DELETE')"
        icon="i-woot-bin"
        slate
        sm
        class="hover:enabled:text-n-ruby-11 hover:enabled:bg-n-ruby-2"
        @click="$emit('delete', automation)"
      />
    </div>
  </div>
</template>
